export const CUSTOMER_SERVICE_DROPDOWN = 'customerServiceHeaderDropdown';

export const CUSTOMER_SERVICE_MENU_SLOT = 'customer-service-menu';

export const SELECTED_TAB_STORAGE_KEY = 'selectedShopTab';

export const LANDING_PRINT_PAGES = {
  'native-shoes-remix-project': 'REMIX',
  'cottons-blue-jeans-go-green': 'COTTON',
  'soles-4-souls': 'GIVE01',
  'kids-in-need-foundation': 'KINF',
  'spread-the-word-nevada': 'STWN'
} as const;
